export enum IndustrySectorEnum {
    HEALTH_SYSTEM = 'Gesundheitswesen',
    INDUSTRIAL_CUSTOMER = 'Industriekunde',
    PUBLIC_CLIENT = 'Öffentlicher Auftraggeber',
    FINANCIAL_SYSTEM = 'Finanzwesen',
}

